export const GET_PROGRESSNOTE_SETTING = "GET_PROGRESSNOTE_SETTING";
export const GET_PROGRESSNOTE_DETAILS = "GET_PROGRESSNOTE_DETAILS";
export const GET_PROGRESSNOTES = "GET_PROGRESSNOTES";
export const GET_ADMIN_NOTES = "GET_ADMIN_NOTES";
export const GET_DEFAULT_PROGRESSNOTE = "GET_DEFAULT_PROGRESSNOTE";
export const REMOVE_NOTE = "REMOVE_NOTE";
export const GET_ADMIN_PROGRESSNOTE_SETTING = "GET_ADMIN_PROGRESSNOTE_SETTING";

export const GET_TERMINATION_NOTE_DETAILS = "GET_TERMINATION_NOTE_DETAILS";
export const GET_ADMIN_TERMINATION_NOTE = "GET_ADMIN_TERMINATION_NOTE";
export const GET_TERMINATION_NOTES = "GET_TERMINATION_NOTES";
export const REMOVE_TERMINATION_NOTE = "REMOVE_TERMINATION_NOTE";

export const setTerminationNoteAction = (payload) => ({ type: GET_TERMINATION_NOTES, payload });
export const setAdminTerminationAction = (payload) => ({ type: GET_ADMIN_TERMINATION_NOTE, payload });
export const setTerminationDetailAction = (payload) => ({ type: GET_TERMINATION_NOTE_DETAILS, payload });
